const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      let variant = {
        id: input.getAttribute('data-variant-id')
      }
      if(input.checked){
        checkWishlist(variant,input)
      }
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        
        // junio edit disable inputs while image loads
        wrapper.querySelectorAll('input').forEach(i => i.disabled = true);

        if (event.currentTarget.checked && primaryImage) {
          // junio edit check first if element exist
          wrapper.querySelector('.js-color-swatches-link')?.setAttribute('href', event.currentTarget.dataset.variantLink);
          const quickviewBtn = wrapper.querySelector('[data-product-url]');
          if (quickviewBtn && event.currentTarget.dataset.variantId) {
            const baseUrl = quickviewBtn.dataset.productUrl.split('?')[0];
            quickviewBtn.setAttribute('data-product-url', baseUrl + '?view=popup&variant=' + event.currentTarget.dataset.variantId);
          }
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }
          
          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

            if (variant) {
              checkWishlist(variant,input)
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);

              // find second media for this variant (next media after featured, not another variant's featured)
              const otherVariantMediaIds = new Set(
                product.variants
                  .filter(v => v.featured_media && v.featured_media.id !== variant.featured_media.id)
                  .map(v => v.featured_media.id)
              );
              let foundPrimary = false;
              let newSecondMediaData = null;
              for (const media of product.media) {
                if (foundPrimary && !newSecondMediaData && !otherVariantMediaIds.has(media.id)) {
                  newSecondMediaData = media;
                }
                if (media.id === variant.featured_media.id) foundPrimary = true;
              }
              const newSecondaryImage = newSecondMediaData
                ? createImageElement(newSecondMediaData, (secondaryImage || primaryImage).className.replace('media--first', 'media--second'), primaryImage.sizes, product.title)
                : null;
              if (newSecondaryImage) newSecondaryImage.className = newSecondaryImage.className.replace('media--first', 'media--second');

              const enableInputs = () => wrapper.querySelectorAll('input').forEach(i => i.disabled = false);
              // fallback: re-enable if image fails to load
              newPrimaryImage.addEventListener('error', enableInputs);

              if (newPrimaryImage.src !== primaryImage.src) {
                primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" });
                setTimeout(function(){
                  primaryImage.replaceWith(newPrimaryImage);
                  newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                  if (secondaryImage) secondaryImage.remove();
                  if (newSecondaryImage) newPrimaryImage.insertAdjacentElement('afterend', newSecondaryImage);
                  enableInputs();
                }, 200);
              } else {
                // primary unchanged, still update secondary
                if (secondaryImage) secondaryImage.remove();
                if (newSecondaryImage) newPrimaryImage.insertAdjacentElement('afterend', newSecondaryImage);
                enableInputs();
              }
            } else {
              wrapper.querySelectorAll('input').forEach(i => i.disabled = false);
            }
          });
        } else {
          // junio edit able inputs after image loads
          wrapper.querySelectorAll('input').forEach(i => i.disabled = false);
        }
      })
    })
  })
}

function initQuickView() {
  document.querySelectorAll('modal-opener').forEach(el => {
    customElements.upgrade(el);
  });
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
    initQuickView();
  });
}
// added by Yudi
async function getWishlist() {
  const customerId = window.var.customer_id;
  const xtoken = window.var.wishlist_token;

  let wishlistData = [];

  try {

    if(customerId){

      const response = await fetch(
        `https://api.myshopapps.com/wishlist/V2/fetchWishlistData/${customerId}`,
        {
          method:'GET',
          headers:{
            xtoken: xtoken,
            Accept:'application/json'
          }
        }
      );

      const data = await response.json();
      wishlistData = data.result;

    }else{

      const response = await fetch(
        'https://api.myshopapps.com/wishlist/V2/fetchWishlistDataWithoutLogin',
        {
          method:'POST',
          headers:{
            xtoken: xtoken,
            'Content-Type':'application/x-www-form-urlencoded',
            Accept:'application/json'
          },
          body:new URLSearchParams({
            wishlist: localStorage.getItem("iwish_list") || '[]',
            c_code:'US',
            lg_code:'EN'
          })
        }
      );

      const data = await response.json();
      wishlistData = data.result;

    }
    /* fetch semua product sekaligus */
    return wishlistData

  } catch(e){
    console.error(e);
  }
}
async function checkWishlist(variant,el){
  let card = el.closest('.card-wrapper')
  let wishlistBtn = card.querySelector('.iWishAddColl')
  let wishlistData = await getWishlist()
  let check = wishlistData?.find(item => item.variant.id == variant.id)
  if(wishlistBtn){
    wishlistBtn.setAttribute('data-variant',variant.id)
    if(check){
      wishlistBtn.classList.add('iwishAdded')
      wishlistBtn.querySelector('svg path')?.setAttribute('fill','#000')
    } else {
      wishlistBtn.classList.remove('iwishAdded')
      wishlistBtn.querySelector('svg path')?.setAttribute('fill','none')
    }
  }
}
// end added by Yudi
(function () {
colorSwatches();
})()